<template>
  <div class="form main-content__form">
    <div class="main-content__row" v-for="(customer, index) in customers" v-bind:key="index">
      <div class="main-conten__member-title">Участник #{{ index + 1 }}
        <span class="customer-one" v-if="membersCount > 1 && index < 1">Основное контактное лицо</span>
      </div>
      <div class="form__input-wrap main-content__elem_half" v-if="customerFieldsToShow.includes('first_name')"
           v-bind:class="customer.first_name.isError ? 'warning' : ''">
        <label class="form__label" for="first_name">
          ФАМИЛИЯ
        </label>
        <input class="form__input" type="text" v-model="customer.first_name.value" autocomplete="on"
               name="first_name" id="first_name" :placeholder="firstNamePlaceholder" @keyup="keyUpFirstName(index)"/>
        <span class="form__error-masage" v-if="customer.first_name.error">{{ customer.first_name.error }}</span>
      </div>

      <div class="form__input-wrap main-content__elem_half" v-bind:class="customer.name.isError ? 'warning' : ''"
           v-if="customerFieldsToShow.includes('name')">
        <label class="form__label" for="name">
          ИМЯ
        </label>
        <input class="form__input" type="text" v-model="customer.name.value" autocomplete="on"
               name="name" id="name" :placeholder="namePlaceholder" @keyup="keyUpName(index)"/>
        <span class="form__error-masage" v-if="customer.name.error">{{ customer.name.error }}</span>
      </div>

      <div class="form__input-wrap main-content__elem_half" v-bind:class="customer.sex.isError ? 'warning' : ''"
           v-if="customerFieldsToShow.includes('sex')">
        <label class="form__label">
          ПОЛ
        </label>
        <div class="radio-wrap">
          <template v-for="item in sex">
            <input class="form__input radio-input" type="radio" v-model="customer.sex.value"
                   v-bind:name="'sex' + index" v-bind:id="item.name + index" v-bind:value="item.name"
                   v-show="false" v-bind:key="item.name"/>
            <label v-bind:for="item.name + index" class="radio-label"
                   v-bind:class="customer.sex.isError ? 'warning' : ''" v-bind:key="item.name"
            >{{ item.value }}</label>
          </template>
        </div>
      </div>

      <div class="form__input-wrap main-content__elem_half" v-if="customerFieldsToShow.includes('birth_date')"
           v-bind:class="customer.birth_date.isError ? 'warning' : ''">
        <label class="form__label" for="birth_date">
          ДАТА РОЖДЕНИЯ
        </label>
        <cleave class="form__input" type="text" v-model="customer.birth_date.value"
                id="birth_date" name="birth_date" placeholder="ДД.ММ.ГГГГ" :options="dateFieldOptions" :raw="false"
                autocomplete="off"/>
        <span class="form__error-masage" v-if="customer.birth_date.error">{{ customer.birth_date.error }}</span>
      </div>

      <div class="form__input-wrap main-content__elem_half" v-bind:class="customer.passport.isError ? 'warning' : ''"
           v-if="customerFieldsToShow.includes('passport')">
        <label class="form__label" for="passport">
          ЗАГРАНИЧНЫЙ ПАСПОРТ
        </label>
        <cleave class="form__input" type="text" v-model="customer.passport.value" :options="passportFieldOptions"
                id="passport" name="passport" placeholder="00 0000000" autocomplete="on" :raw="false"/>
        <span class="form__error-masage" v-if="customer.passport.error">{{ customer.passport.error }}</span>
      </div>

      <div class="form__input-wrap main-content__elem_half" v-bind:class="customer.passport_rf.isError ? 'warning' : ''"
           v-if="customerFieldsToShow.includes('passport_rf')">
        <label class="form__label" for="passport_rf">
          ПАСПОРТ РФ
        </label>
        <cleave class="form__input" type="text" v-model="customer.passport_rf.value" :options="passportRfFieldOptions"
                id="passport_rf" name="passport_rf" placeholder="0000 000000" autocomplete="on" :raw="false"/>
        <span class="form__error-masage" v-if="customer.passport_rf.error">{{ customer.passport_rf.error }}</span>
      </div>

      <div class="form__input-wrap main-content__elem_half" v-if="customerFieldsToShow.includes('passport_date')"
           v-bind:class="customer.passport_date.isError ? 'warning' : ''">
        <label class="form__label" for="passport_date">
          СРОК ОКОНЧАНИЯ ДЕЙСТВИЯ ПАСПОРТА
        </label>
        <cleave class="form__input" type="text" v-model="customer.passport_date.value"
                :options="passportDateFieldOptions"
                id="passport_date" name="passport_date" placeholder="ДД.ММ.ГГГГ" autocomplete="on" :raw="false"/>
        <span class="form__error-masage" v-if="customer.passport_date.error">{{ customer.passport_date.error }}</span>
      </div>

      <div class="form__input-wrap main-content__elem_half" v-if="customerFieldsToShow.includes('citizenship')"
           v-bind:class="customer.citizenship.isError ? 'warning' : ''">
        <label class="form__label" for="citizenship">
          ГРАЖДАНСТВО
        </label>
        <input class="form__input" type="text" v-model="customer.citizenship.value" name="citizenship"
               placeholder="RUSSIAN FEDERATION" autocomplete="on" @keyup="keyUpCitizenship(index)" id="citizenship"/>
        <span class="form__error-masage" v-if="customer.citizenship.error">{{ customer.citizenship.error }}</span>

        <div class="city-popup" v-show="customer.cities && customer.cities.length">
          <ul>
            <li v-for="city in customer.cities" v-bind:key="city">
              <span @click="cityClick(index, city)">{{ city }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="form__input-wrap main-content__elem_half"
           v-bind:class="(customer.phone.isValid || (customer.phone.isValid === undefined && !customer.phone.isError)) ? 'valid' : 'warning'"
           v-if="customerFieldsToShow.includes('phone')">
        <label class="form__label" :for="'phone' + index">
          НОМЕР ТЕЛЕФОНА
        </label>

        <!--<input class="form__input" type="text" :id="'phone' + index" name="phone"
               @input="validatePhone($event, index)" @countrychange="validatePhone($event, index)" autocomplete="on"/>-->

        <vue-tel-input
          v-bind="phoneFieldOptions"
          @input="(number, input) => {validatePhone(number, input, index)}"
        > v-model="customer.phone.value"></vue-tel-input>

        <span class="form__error-masage" v-if="!customer.phone.isValid">{{ customer.phone.error }}</span>
      </div>

      <div class="form__input-wrap main-content__elem_half" v-bind:class="customer.email.isError ? 'warning' : ''"
           v-if="customerFieldsToShow.includes('email')">
        <label class="form__label" for="email">
          электронная почта
        </label>
        <input class="form__input" type="text" v-model="customer.email.value" name="email" id="email"
               placeholder="example@email.com" autocomplete="on" @keyup="keyUpEmail(index)"/>
        <span class="form__error-masage" v-if="customer.email.error">{{ customer.email.error }}</span>
      </div>

      <div class="field" v-if="customerFieldsToShow.includes('t_shirt_size')">
        <div class="form__input-wrap" v-bind:class="customer.t_shirt_size.isError ? 'warning' : ''">
          <label class="form__label">
            Размер футболки
          </label>
          <div class="radio-wrap">
            <template v-for="item in sizes">
              <input class="form__input radio-input"
                     type="radio" v-model="customer.t_shirt_size.value"
                     v-bind:name="'t_shirt_size' + index" v-bind:id="item + index" v-bind:value="item"
                     v-show="false" v-bind:key="item"/>
              <label v-bind:for="item + index" class="radio-label" v-bind:key="item"
                     v-bind:class="customer.sex.isError ? 'warning' : ''">{{ item }}</label>
            </template>
          </div>
          <span class="form__error-masage">Выберите размер</span>
        </div>
      </div>
    </div>
    <div class="main-content__row contacts" v-if="customers.length == membersCount && partialSums.length > 0">
      <div class="form__checkbox-wrap">
        <label class="form__checkbox-label" v-for="(pay, index) in partialSums" v-bind:key="index">
          <input class="form__checkbox" type="radio" v-model="partialPercent"
                 name="partial_percent" v-bind:value="pay.value">
          <span class="form__checkbox-text">Хочу оплатить {{ pay.value }}%</span>
        </label>
      </div>
    </div>

    <mobile-price/>

    <div class="main-content__row">
      <div class="button-wrap"><!--button_disabled-->
        <router-link :to="{name: 'events'}" class="form__button button back_button" @click="submit">
          Назад
        </router-link>
        <button class="form__button button " value="Далее" @click="submit">
          Далее
        </button>
        <!--<span class="button_disabled-before">Необходимо заполнить все поля</span>-->
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import {mapActions} from 'vuex'
  import {mapMutations} from 'vuex'
  import axios from 'axios'
  import Vue from 'vue'
  import $ from 'jquery'
  import 'jquery-mask-plugin'
  import Cleave from 'vue-cleave-component'
  import MobilePrice from "./MobilePrice";
  import intlTelInput from "intl-tel-input"
  import { VueTelInput } from 'vue-tel-input'

  export default {
      watch: {
          partialPercent: function () {
              this.setPartial(this.partialPercent);
          }
      },
    beforeMount() {
      if (this.$router.currentRoute.params.eventId) {
        this.setCurrentEventId(this.$router.currentRoute.params.eventId);
        this.getEvent();
        this.setPartialSum(this.state)
      }
    },
    mounted() {
      this.setCustomersLessThanMembers();

      $(document).mouseup((e) => {
        const div = $(".city-popup");

        if (!div.is(e.target)
          && div.has(e.target).length === 0) {
          for (let a in this.customers) {
            Vue.set(this.customers[a], 'cities', []);
          }
        }
      });

      if (typeof this.state !== "undefined" ) {
          this.partialPercent = this.state.partialPay.percent;
      }
    },

    updated() {
      for (let a in this.customers) {
        this.initPhoneInput("#phone" + a);
        if (typeof this.customers[a].phone !== 'undefined') {
          $('#phone' + a).val(this.customers[a].phone.value)
        }
      }
    },

    methods: {
      submit: function () {
        this.checkCustomers();
      },
      cityClick: function (index, city) {
        this.customers[index].citizenship.value = city;

        Vue.set(this.customers[index], 'cities', []);
      },
      keyUpName: function (index) {
        const regRu = /[а-яА-Я0-9ёЁ]/g;
        const regEn = /[a-zA-Z0-9]/g;

        if (this.currentEvent.name_language === 'en') {
          if (this.customers[index].name.value.search(regRu) != -1) {
            this.customers[index].name.value = this.customers[index].name.value.replace(regRu, '');
          }
        }

        if (this.currentEvent.name_language === 'ru') {
          if (this.customers[index].name.value.search(regEn) != -1) {
            this.customers[index].name.value = this.customers[index].name.value.replace(regEn, '');
          }
        }

        this.customers[index].name.value = this.customers[index].name.value.toUpperCase()
      },
      keyUpEmail(index) {
        this.customers[index].email.value = this.customers[index].email.value.toLowerCase()
      },
      keyUpFirstName: function (index) {
        const regRu = /[а-яА-Я0-9ёЁ]/g;
        const regEn = /[a-zA-Z0-9]/g;

        if (this.currentEvent.name_language === 'en') {
          if (this.customers[index].first_name.value.search(regRu) != -1) {
            this.customers[index].first_name.value = this.customers[index].first_name.value.replace(regRu, '');
          }
        }

        if (this.currentEvent.name_language === 'ru') {
          if (this.customers[index].first_name.value.search(regEn) != -1) {
            this.customers[index].first_name.value = this.customers[index].first_name.value.replace(regEn, '');
          }
        }

        this.customers[index].first_name.value = this.customers[index].first_name.value.toUpperCase()
      },
      keyUpCitizenship: function (index) {
        const reg = /[а-яА-Я0-9ёЁ]/g;

        if (this.customers[index].citizenship.value.search(reg) != -1) {
          this.customers[index].citizenship.value = this.customers[index].citizenship.value.replace(reg, '');
        }

        this.customers[index].citizenship.value = this.customers[index].citizenship.value.toUpperCase();

        if (this.customers[index].citizenship.value.length > 1) {
          const val = this.customers[index].citizenship.value;

          axios.get('/api/city/' + val).then((res) => {
            Vue.set(this.customers[index], 'cities', res.data);
          });
        } else {
          Vue.set(this.customers[index], 'cities', []);
        }

      },
      capitalize: function (str) {
        const splitStr = str.toLowerCase().split(' ');

        for (var i = 0; i < splitStr.length; i++) {
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }

        return splitStr.join(' ');
      },
      validatePhone: function (number, input, index) {
        var
          customerIndex = index,

          isValid = input.isValid,
          itiNumber = input.number.international;

        this.setCustomerPhone({customerIndex, itiNumber});
        this.validateCustomerPhone({itiNumber, isValid});
      },
      initPhoneInput: function (selector) {
        var input = $(selector).get(0);

        if (typeof input !== "undefined") {
          intlTelInput(input, {
            mode: "international",
            nationalMode: false,
            autoPlaceholder: "aggressive",
            defaultCountry: "RU",
            formatOnDisplay: true,
            disabledFetchingCountry: false,
            disabled: false,
            disabledFormatting: false,
            placeholder: "Введите номер",
            required: false,
            enabledCountryCode: true,
            enabledFlags: true,
            preferredCountries: ['RU'],
            ignoredCountries: [],
            //separateDialCode: true,
            utilsScript: '/js/utils.js',
            autocomplete: "off",
            maxLen: 35,
            wrapperClasses: "",
            inputClasses: "",
            dropdownOptions: {
              disabledDialCode: false
            },
            inputOptions: {
              showDialCode: false,
            },
          });
        } else {
          console.log("input undefined")
        }
      },
      ...mapActions([
        'checkCustomers',
        'getEvent'
      ]),
      ...mapMutations([
        'setCustomersLessThanMembers',
        'setCurrentEventId',
        'validateCustomerPhone',
        'setCustomerPhone',
        'setPartial',
          'setPartialSum',
      ]),
    },
    data: function () {
      return {
        sex: [
          {
            'name': 'man',
            'value': 'М'
          },
          {
            'name': 'woman',
            'value': 'Ж'
          },
        ],
        sizes: [
          'XS',
          'S',
          'M',
          'L',
          'XL',
          'XXL',
          'XXXL'
        ],
        dateFieldOptions: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'Y'],
          dateMax: '2050-01-01',
        },
        passportDateFieldOptions: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'Y'],
          dateMax: '2050-01-01',
        },
        passportFieldOptions: {
          numericOnly: true,
          blocks: [2, 7],
          delimiters: [" "],
        },
        passportRfFieldOptions: {
          numericOnly: true,
          blocks: [4, 6],
          delimiters: [" "],
        },
        phoneFieldOptions: {
          mode: "international",
          nationalMode: false,
          autoPlaceholder: "aggressive",
          defaultCountry: "RU",
          formatOnDisplay: true,
          disabledFetchingCountry: false,
          disabled: false,
          disabledFormatting: false,
          placeholder: "Введите номер",
          required: false,
          enabledCountryCode: true,
          enabledFlags: true,
          preferredCountries: ['RU'],
          ignoredCountries: [],
          utilsScript: '/js/utils.js',
          name:"phone",
          autocomplete: "off",
          maxLen: 35,
          wrapperClasses: "",
          inputClasses: "",
          dropdownOptions: {
            disabledDialCode: false
          },
          inputOptions: {
            showDialCode: false,
          },
        },
        birthDateError: false,
          partialPercent: this.$store.state.partialPay.percent,
      }
    },
    computed: {
        partialSums: function () {
            if (this.currentEvent && this.currentEvent.partial_pays) {
                let pays = []

                for (const value of Object.entries(this.currentEvent.partial_pays)) {
                    if (typeof value[1].active !== "undefined" && (parseInt(value[1].active) === 1 || value[1].active === true)) {
                        pays.push(value[1]);
                    }
                }

                return pays.sort(function (a, b) {
                    return a.value - b.value;
                });
            }

            return [];
        },
      customersCount: function () {
        return this.customers.length;
      },
      namePlaceholder: function () {
        return this.currentEvent.name_language === 'en' ? 'TATIANA' : 'ТАТЬЯНА';
      },
      firstNamePlaceholder: function () {
        return this.currentEvent.name_language === 'en' ? 'LEBEDEVA' : 'ЛЕБЕДЕВА';
      },
      customerFieldsToShow() {
        if (!this.currentEvent.event_customer_fields) {
          return [];
        }

        return this.currentEvent.event_customer_fields.map(function (item) {
          return item.code;
        });
      },
      partialSumValue: {
        get() {
          return this.$store.state.partialPay.sum
        },
        set(value) {
          this.$store.commit('setPartialSumValue', value)
        }
      },
      ...mapState([
        'customers',
        'membersCount',
        'currentEvent',
        'partial',
      ]),
      ...mapGetters([
        'eventPrice',
        'convertedPrice',
        'currencySymbol'
      ]),
    },
    components: {
      MobilePrice,
      Cleave,
      VueTelInput
    }
  }
</script>
<style>
  .city-popup {
    position: absolute;
    background: #fff;
    z-index: 1;
    border: 1px solid #c5c0c0;
    padding: 10px;
    left: -14px;
    color: #373637;
    font-size: 16px;
    box-shadow: 0 7px 21px rgba(83, 92, 105, .12), 0 -1px 6px 0 rgba(83, 92, 105, .06);
  }

  .city-popup li {
    list-style: none;
    cursor: pointer;
  }

  .customer-one {
    font-size: 16px;
  }

  .main-content__elem_half.warning input[name="phone"] {
    border-bottom: 2px solid red;
    background: #fafafa;
  }

  .main-content__elem_half.valid input[name="phone"] {
    border-bottom: 2px solid greenyellow;
    background: #fafafa;
  }

  .contacts .form__checkbox-text {
    padding-right: 0;
    padding-left: 50px;
  }

  .contacts .form__checkbox-text:before {
    left: 0;
  }

  .contacts .form__checkbox-text:after {
    display: none;
  }

  .contacts .partial-input {
    display: inline-block;
    width: 100px;
    border: 1px solid #ddd;
    padding: 5px 5px;
    border-radius: 5px;
    margin-right: 10px;
  }

  .form__input-wrap .iti__flag {
    background-color: unset;
  }
</style>
